import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import classNames from 'classnames';
import { ADGMResponsiveModal, AuroraButton } from 'aurora-components';
import { keyEmptyCheck } from 'aurora-utils/utils';
import FetchUser from './FetchUser';
import styles from './styles';

const initialState = {
  userType: 'person',
  eidOrUnified: '',
};

function AddContactModal(props) {
  const {
    intl,
    locale,
    modalConfig,
    handleModalClose,
    modalTitle,
    buttonText,
    apiResponse,
    classes,
    handleFetchUser,
    handleAddPrimaryContact,
    FieldComponent,
  } = props;
  const [formState, setFormState] = useState(initialState);

  const isResponsePerson = apiResponse && !(apiResponse?.tradeLicenseNo || apiResponse.tradeLicenseNumber);

  useEffect(() => {
    return () => {
      setFormState(initialState);
    };
  }, []);

  useEffect(() => {
    setFormState({
      ...formState,
      email: modalConfig?.data?.email,
      mobile: modalConfig?.data?.phoneNumber,
    });
  }, [modalConfig?.data]);

  const handleStateChange = e => {
    setFormState({
      ...formState,
      [e.target.name]: e.target.value,
    });
  };

  const handleSelect = (name, value) => {
    setFormState(state => ({
      ...state,
      [name]: value?.value || null,
    }));
  };

  const fetchUser = () => {
    let id = null;
    if (formState.userType === 'person') {
      id = formState.eidOrUnified?.replace(/-/g, '');
    }
    handleFetchUser(id, formState.userType);
  };

  const onModalClose = () => {
    setFormState(initialState);
    handleModalClose();
  };

  const addPrimaryContact = () => {
    delete formState.userType;
    handleAddPrimaryContact(formState);
    setFormState(initialState);
  };

  return (
    <ADGMResponsiveModal
      open={modalConfig.open}
      toggleModal={onModalClose}
      onClose={onModalClose}
      title={modalTitle}
      disablePortal
    >
      {/*  eslint-disable-next-line  */}
      {/* <ADGMImage
        onClick={onModalClose}
        name="delete-pma.svg"
        className={classes.cancelModal}
        alt="delete"
      /> */}
      <div>
        {/* <Typography className={classes.modalSubtitle} gutterBottom>
          {keyEmptyCheck("primary_contact_details")}
        </Typography> */}
        <FetchUser
          formState={formState}
          handleStateChange={handleStateChange}
          fetchUser={fetchUser}
          isEditMode={modalConfig.isEditMode}
        />
        {/* Input fields container */}
        {modalConfig?.data && (
          <FieldComponent
            locale={locale}
            intl={intl}
            formState={formState}
            apiResponse={apiResponse}
            isResponsePerson={isResponsePerson}
            handleStateChange={handleStateChange}
            handleSelect={handleSelect}
            modalConfig={modalConfig}
          />
        )}
        <div className={classes.modalFooter}>
          <Box display='flex' justifyContent='space-between' className={classes.subPanel}>
            <AuroraButton type='button' onClick={onModalClose}>
              {keyEmptyCheck('cancel')}
            </AuroraButton>
            <Button
              className={classNames(classes.mediumButton, classes.addBuyerButton)}
              disabled={!modalConfig?.data}
              onClick={addPrimaryContact}
            >
              {buttonText}
            </Button>
          </Box>
        </div>
      </div>
    </ADGMResponsiveModal>
  );
}

AddContactModal.propTypes = {
  classes: PropTypes.object.isRequired,
  intl: PropTypes.object.isRequired,
  locale: PropTypes.string.isRequired,
  modalConfig: PropTypes.object.isRequired,
  modalTitle: PropTypes.node.isRequired,
  buttonText: PropTypes.node.isRequired,
  apiResponse: PropTypes.object.isRequired,
  handleFetchUser: PropTypes.func.isRequired,
  handleAddPrimaryContact: PropTypes.func.isRequired,
  handleModalClose: PropTypes.func.isRequired,
  FieldComponent: PropTypes.node.isRequired,
};

AddContactModal.defaultProps = {};

export default withStyles(styles)(AddContactModal);
